import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CompanyImage from "../common/company_image";
import Experience from "./experience";
import CareerForm from "./career_form";

class CareerEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      isDeleteModalShow: false
    };
  }

  handleCareerEditButtonClick = () => {
    this.setState(prevState => (
      { isEditing: !prevState.isEditing }
    ));
  };

  handleDeleteModalShow = () => {
    this.setState(prevState => (
      { isDeleteModalShow: !prevState.isDeleteModalShow }
    ));
  };

  handleDeleteButtonClick = (event) => {
    event.preventDefault();
    const { career, actions } = this.props;
    actions.deleteCareer(career);
  }

  render () {
    const { isEditing, isDeleteModalShow } = this.state;
    const { career, isEditMode } = this.props;
    const company = career.company;

    return (
      <React.Fragment>
        <td className='company-logo editable'>
          <span>
            <CompanyImage company={company} {...this.props} />
          </span>
        </td>

        { isEditing === true && (
          <td style={{width: "100%"}}>
            <CareerForm
              {...this.props}
              career={career}
              handleCareerEditButtonClick={this.handleCareerEditButtonClick}
            />
          </td>
        )}

        { isEditing === false && (
          <td className='company-info'>
            <h5 className='company-name'>{company.name}</h5>
            { career.experiences.map(experience  => {
              return (
                <Experience key={experience.id} experience={experience} />
              );
            })}

            { isEditMode && (
              <p>
                <button type="button" className='btn-profile-edit float-left mr-2' onClick={this.handleCareerEditButtonClick}>
                  <i className="fas fa-edit" />
                </button>
                {" "}
                <button type="button" className='btn-profile-edit float-left' onClick={this.handleDeleteModalShow}>
                  <i className="fas fa-trash" />
                </button>

                <Modal isOpen={isDeleteModalShow} toggle={this.handleDeleteModalShow}>
                  <ModalHeader toggle={this.handleDeleteModalShow}>経歴の削除</ModalHeader>
                  <ModalBody>
                    {company.name}
                    {" "}
の経歴を削除しますか？
                  </ModalBody>
                  <ModalFooter>
                    <Button color="outline-primary" onClick={this.handleDeleteModalShow}>キャンセル</Button>
                    {" "}
                    <Button color="primary" onClick={this.handleDeleteButtonClick}>削除する</Button>
                  </ModalFooter>
                </Modal>
              </p>
            )}
          </td>
        )}
      </React.Fragment>
    );
  }
}

CareerEdit.propTypes = {
  career: PropTypes.shape({
    id: PropTypes.number.isRequired,
    company: PropTypes.object.isRequired,
    experiences: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  isEditMode: PropTypes.bool.isRequired
};

export default CareerEdit;
